export class PasswordResetRequestViewModel {
    username: string;
    origin: string;
  }
